import { APIPath } from '@utility/constants/api';
import { BaseService } from './base';

const portal = import.meta.env.VITE_PORTAL;

class ClientConfig {
  get = () =>
    BaseService.get(`${APIPath.clientConfig}?portal=${portal}`, false, false);
}

const ClientConfigService = new ClientConfig();
Object.freeze(ClientConfigService);
export default ClientConfigService;
